


















import { Component, Prop, Vue } from 'vue-property-decorator'
import NotificationsBloc from '@/components/Dashboard/NotificationsBloc.vue'
import Profil from '@/components/Dashboard/Profil.vue'
import Planning from '@/components/Dashboard/Planning.vue'
import Blog from '@/components/Dashboard/Blog.vue'
import AppartBloc from '@/components/Dashboard/AppartBloc.vue'
import Programmation from '@/components/Dashboard/Programmation.vue'
import AvancementDashboard from '@/components/Dashboard/AvancementDashboard.vue'
import Ticket from '@/components/Ticket.vue'
import Progope from '@/components/ProgImmo/Progope.vue'
import ProgAlert from '@/components/Dashboard/ProgAlert.vue'
import LaCopro from '@/components/Dashboard/LaCopro.vue'

@Component({
    components: {
        NotificationsBloc,
        Profil,
        Planning,
        Blog,
        AppartBloc,
        Programmation,
        AvancementDashboard,
        Ticket,
        Progope,
        ProgAlert,
        LaCopro,
    },
})
export default class Dashboard extends Vue {
    // @Prop() private title!: string;
}
